var serverUrl = "";
var serverWebUrl = "";
var serverPrintUrl = "";
var imgaddpath = "";

function getServerUrl () {
  return serverUrl;
}

function getServerWebUrl () {
  return serverWebUrl;
}

function getServerPrintUrl () {
  return serverPrintUrl;
}

function setServerUrl (url) {
  localStorage.setItem("ystadminurl", url);
  serverUrl = url;
}

function getimgaddpath () {
  return imgaddpath;
}

function init () {


  //测试版
  //serverUrl = `http://${document.domain}:28001/`
  //后端加代理
  serverUrl = `http://${location.host}/28001/`
  //serverUrl = `https://${location.host}/28001/`
  //serverUrl = `https://${location.host}/28003/`
  //serverUrl = `https://${location.host}/smkjyserver/`
  //serverUrl = `http://${location.host}/hnsrmyyserver/`
  //serverUrl = `http://${location.host}/sbzxserver/`
  imgaddpath=``
  //imgaddpath=`/hnsrmyy`

  //标准设置
  serverWebUrl = `http://${location.host}/`
  //serverWebUrl = `https://${location.host}/`

  //打印接口
  serverPrintUrl = `http://${document.domain}:28002/`
}

export default {
  getServerUrl, getServerWebUrl, setServerUrl, init, getServerPrintUrl,getimgaddpath
}



// WEBPACK FOOTER //
// ./src/config/index.js